const opacity = {
    name: "opacity",
    path: "opacity",
    title: "opacity",
    description: "Utilities for controlling the CSS opacity property.",
    value: {
        "opacity": {
            "opacity-<number>": "<number>",
        }
    },
    exampleData: [
        {
            "title": "opacity-<number>",
            "description": "utilities like opacity-25 and opacity-100 to set the opacity of an element:",
            "moreDescription": "",
            "parentClass": "flex gap-6 *:mb-6 !bg-none !border-0 !mt-8",
            "example": {
                "element": "img",   
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "aspect-square object-cover w-full opacity-100"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "aspect-square object-cover w-full opacity-75"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "aspect-square object-cover w-full opacity-50"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "aspect-square object-cover w-full opacity-25"
                    },
                ],
                "className": "rounded-lg overflow-hidden",
                "code": `<img class="opacity-100 ..." src="/img/image.jpg" />
<img class="opacity-75 ..." src="/img/image.jpg" />
<img class="opacity-50 ..." src="/img/image.jpg" />
<img class="opacity-25 ..." src="/img/image.jpg" />`
            }
        }
    ]
};

export default opacity;